import { __rest, __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { Root, Trigger, Portal } from '../../../../_externals/.pnpm/@radix-ui_react-dialog@1.1.1_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-dialog/dist/index.js';
import '../../atoms/Icons/Minus/Minus.js';
import '../../atoms/Icons/Plus/Plus.js';
import '../../atoms/Icons/Right/Right.js';
import '../../atoms/Icons/Left/Left.js';
import '../../atoms/Icons/Down/Down.js';
import '../../atoms/Icons/Up/Up.js';
import '../../atoms/Icons/Tick/Tick.js';
import Cross from '../../atoms/Icons/Cross/Cross.js';
import '../../atoms/Icons/Hamburger/Hamburger.js';
import '../../atoms/Icons/Search/Search.js';
import '../../atoms/Icons/Cart/Cart.js';
import '../../atoms/Icons/Filter/Filter.js';
import '../../atoms/Icons/Profile/Profile.js';
import '../../atoms/Icons/ProfileCircleOutline/ProfileCircleOutline.js';
import '../../atoms/Icons/LoadingCircle/LoadingCircle.js';
import '../../atoms/Icons/CrossSolidCircleOutline/CrossSolidCircleOutline.js';
import '../../atoms/Icons/RadioButtonOutline/RadioButtonOutline.js';
import '../../atoms/Icons/RadioButtonSolid/RadioButtonSolid.js';
import '../../atoms/Icons/ArrowDownCircleOutline/ArrowDownCircleOutline.js';
import '../../atoms/Icons/MinusCircleOutline/MinusCircleOutline.js';
import '../../atoms/Icons/PlusCircleOutline/PlusCircleOutline.js';
import '../../atoms/Icons/ArrowUpCircleOutline/ArrowUpCircleOutline.js';
import '../../atoms/Icons/InfoSolidCircleOutline/InfoSolidCircleOutline.js';
import '../../atoms/Icons/WarningSolidCircleOutline/WarningSolidCircleOutline.js';
import '../../atoms/Icons/InfoCircleOutline/InfoCircleOutline.js';
import '../../atoms/Icons/WarningCircleOutline/WarningCircleOutline.js';
import '../../atoms/Icons/CrossCircleOutline/CrossCircleOutline.js';
import '../../atoms/Icons/TickCircleOutline/TickCircleOutline.js';
import '../../atoms/Icons/Socials/Facebook/Facebook.js';
import '../../atoms/Icons/Socials/Instagram/Instagram.js';
import '../../atoms/Icons/Socials/Tiktok/Tiktok.js';
import '../../atoms/Icons/Socials/LinkedIn/LinkedIn.js';
import '../../atoms/Icons/Socials/FacebookWithoutCircle/FacebookWithoutCircle.js';
import '../../atoms/Icons/Payments/Visa/Visa.js';
import '../../atoms/Icons/Payments/Mastercard/Mastercard.js';
import '../../atoms/Icons/Payments/Amex/Amex.js';
import '../../atoms/Icons/Payments/ApplePay/ApplePay.js';
import '../../atoms/Icons/Payments/GooglePay/GooglePay.js';
import '../../atoms/Icons/Payments/Stripe/Stripe.js';
import '../../atoms/Icons/Payments/PoweredByStripe/PoweredByStripe.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoWhite/ApplePayLogoWhite.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoBlack/ApplePayLogoBlack.js';
import '../../atoms/Icons/WalletPayment/GooglePayLogo/GooglePayLogo.js';
import '../../atoms/Icons/Partners/Ups/Ups.js';
import '../../atoms/Icons/Partners/Trustpilot/Trustpilot.js';
import '../../atoms/Icons/Dot/Dot.js';
import { DialogOverlay, DialogAlignment, DialogContent, DialogClose } from './Dialog.styles.js';

var Dialog = function (_a) {
    var open = _a.open, children = _a.children, trigger = _a.trigger, drawer = _a.drawer, align = _a.align, justify = _a.justify, scrollContainer = _a.scrollContainer, width = _a.width, onOpenChange = _a.onOpenChange, fullscreen = _a.fullscreen, _b = _a.hideCloseButton, hideCloseButton = _b === void 0 ? false : _b, props = __rest(_a, ["open", "children", "trigger", "drawer", "align", "justify", "scrollContainer", "width", "onOpenChange", "fullscreen", "hideCloseButton"]);
    return (React.createElement(Root, { open: open, onOpenChange: onOpenChange },
        React.createElement(Trigger, { asChild: true }, trigger),
        React.createElement(Portal, null,
            React.createElement(DialogOverlay, null),
            React.createElement(DialogAlignment, { "data-testid": "dialog-alignment", drawer: drawer, align: align, justify: justify },
                React.createElement(DialogContent, __assign({ "data-testid": props["data-testid"], scrollContainer: scrollContainer, width: width, drawer: drawer, fullscreen: fullscreen }, props),
                    !hideCloseButton && (React.createElement(DialogClose, { fullscreen: fullscreen, "data-testid": "close-dialog" },
                        React.createElement(Cross, { size: "s" }))),
                    children)))));
};

export { Dialog as default };
//# sourceMappingURL=Dialog.js.map
